import { Component, inject, ViewEncapsulation } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { QRCodeComponent } from 'angularx-qrcode'

export interface QrDialogData {
  qrLink: string
  channelName: string
  channelType: 'whatsapp' | 'telegram'
  webLink: string
}

@Component({
  selector: 'app-qr-dialog',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, MatIconModule, QRCodeComponent],
  templateUrl: './qr-dialog.component.html',
  styleUrl: './qr-dialog.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class QrDialogComponent {
  data = inject<QrDialogData>(MAT_DIALOG_DATA)
  dialogRef = inject(MatDialogRef<QrDialogComponent>)
}
